module.exports = __webpack_public_path__ + "img/1.9e7a2259.png";